import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { GroupsProductsList } from './GroupsProductsList'

import { Container } from './style'


export function GroupsOrProductsLinkToCoupons() {
    const [openGroupsSelection, setOpenGroupsSelection] = useState(false)
    const modalForms = useSelector(state =>  state.modalForms)

    useEffect(() => {
        if(!modalForms.isOpen)
            setOpenGroupsSelection(false)
    }, [modalForms])


    return (
        <Container>
            {
                openGroupsSelection &&
                <GroupsProductsList />
            }

            <button
                onClick={() => setOpenGroupsSelection(state => !state)}
            >
                {
                    openGroupsSelection 
                    ? 'Fechar'
                    : 'Vincular produto'
                }
            </button>
        </Container>
    )
}
